import React, { useState } from 'react'
import { Button, Typography } from 'antd'
import { HistoryOutlined, PlusOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { ComplianceStatusIcon } from './compliance-status-icon'
import { ComplianceHistoryModal } from './compliance-history-modal'
import { ComplianceAddModal } from './compliance-add-modal'
import {
  COMPLIANCE_LABELS,
  formatReceiptAmount,
  hasComplianceAlerts,
  isReceiptType,
  type ComplianceCurrentSummary,
  type ComplianceType,
} from '../../types/compliance'
import { HStack } from '../../../../../ui/Stack'

const { Text } = Typography

interface ComplianceBlockProps {
  employeeId: number
  type: ComplianceType
  summary: ComplianceCurrentSummary
  canEdit: boolean
  onRefresh: () => void
  embedded?: boolean
}

export function ComplianceBlock({
  employeeId,
  type,
  summary,
  canEdit,
  onRefresh,
  embedded = false,
}: ComplianceBlockProps) {
  const [historyOpen, setHistoryOpen] = useState(false)
  const [addOpen, setAddOpen] = useState(false)

  const isReceipt = isReceiptType(type)

  const displayLabel = (() => {
    if (isReceipt) {
      if (!summary.record_id) {
        return 'Чеки не найдены'
      }
      const parts: string[] = []
      if (summary.amount) {
        parts.push(formatReceiptAmount(summary.amount))
      }
      if (summary.expires_at) {
        parts.push(dayjs(summary.expires_at).format('DD.MM.YYYY'))
      }
      return parts.length > 0 ? parts.join(', ') : 'Чеки не найдены'
    }

    return summary.expires_at
      ? `до ${dayjs(summary.expires_at).format('DD.MM.YYYY')}`
      : 'дата не указана'
  })()

  const showAlert = hasComplianceAlerts(type)
  const isEmptyState = isReceipt ? !summary.record_id : !summary.expires_at

  return (
    <>
      <HStack
        gap="8"
        max
        wrap
        justify="start"
        align="center"
        style={{ width: '100%', padding: embedded ? 0 : '8px 0' }}
      >
        {!embedded && (
          <Text strong style={{ minWidth: 180 }}>
            {COMPLIANCE_LABELS[type]}
          </Text>
        )}
        <Button
          type="primary"
          size="small"
          icon={<HistoryOutlined />}
          onClick={() => setHistoryOpen(true)}
          title="История"
        />
        {showAlert && <ComplianceStatusIcon alert={summary.alert} />}
        <Text type={isEmptyState ? 'secondary' : undefined}>{displayLabel}</Text>
        {canEdit && (
          <Button
            type="primary"
            size="small"
            icon={<PlusOutlined />}
            onClick={() => setAddOpen(true)}
            title="Добавить"
          />
        )}
      </HStack>

      <ComplianceHistoryModal
        open={historyOpen}
        employeeId={employeeId}
        type={type}
        onClose={() => setHistoryOpen(false)}
      />
      <ComplianceAddModal
        open={addOpen}
        employeeId={employeeId}
        type={type}
        onClose={() => setAddOpen(false)}
        onSuccess={onRefresh}
      />
    </>
  )
}
